export const SECTION_COMPONENT_PATHS = {
  "EntranceExams:TancetManagementComputerApplicationEntranceExam": "./pages/EntranceExams/P0154/P0154.jsx",
  "Scholarships:PerasiriyarAnbazhaganTeacherEducationScholarship": "./pages/Scholarships/P0155/P0155.jsx",
  "Tools:CollegeshineComCutOffCalculatorTamilNadu": "./pages/Tools/CutOff/CutOff.jsx"
}
